

export class PricingDetail {
    id: string;
    plan: string;
    feature: string;
    describtion: string;
}